<template>
  <div class="terminal-result" v-html="result"></div>
</template>
<script>
export default {
  props: ["result"]
};
</script>
